import React from 'react';
import { useUserContext } from 'src/context/UserProvider';

interface Props {
	score: number;
}

const OverallRoundScore = ({ score }: Props) => {
	const { isRecruiterLoggedIn } = useUserContext();
	return (
		<div className="py-[10px] px-4 bg-gray-100 dark:bg-[#18222D] rounded-[8px] w-max border border-solid dark:border-[#e5ffff1a]">
			<div className="dark:text-[#E5FFFF] text-sm font-normal">Meeting Score</div>
			<div className="text-[32px] font-bold mt-1">
				{Math.round(score)} {isRecruiterLoggedIn ? <></> : <span className="text-xl font-normal ">/ 1000</span>}
			</div>
		</div>
	);
};

export default OverallRoundScore;
